/**
 * WebGL background + particle colors (match `body` in `src/index.css` for the clear tone).
 */

/** 1 CSS typographic pt in CSS px (reference pixel at 96dpi). */
export const CSS_PX_PER_PT = 96 / 72;

/**
 * Center-to-center grid spacing in CSS pt.
 * Cols/rows are floor(viewportCss / (spacingPt × CSS_PX_PER_PT))), so density stays consistent across sizes.
 */
export const GRID_SPACING_CSS_PT = 10;

/**
 * Extra grid cells past each viewport edge (left, right, top, bottom), same count per side.
 * Fills margin so noise offsets do not reveal empty canvas at the borders.
 */
export const GRID_OVERFILL_CELLS = 5;

/** WebGL clear color — #fffdf4 */
export const CLEAR_COLOR_RGB = [255, 253, 244] as const;

/** Point sprite fill — #e3e0d4 (muted, slightly lighter than #d5d2c6 vs #fffdf4) */
export const PARTICLE_COLOR_RGB = [227, 224, 212] as const;

/** Point size in CSS typographic points (1pt ≈ 96/72 CSS px). */
export const PARTICLE_POINT_SIZE_CSS_PT = 2;

/**
 * Spatial resolution of the 3D noise in x / y: scale on grid cell coordinates into Perlin space.
 * Lower → larger, smoother blobs; higher → finer-grained noise between neighbors.
 */
export const NOISE_RESOLUTION = 0.02;

/** Multiplier on elapsed time (seconds) for the noise z slice; higher → faster motion. */
export const NOISE_SPEED = 0.03;

/** Offset length in CSS px (canvas multiplies by DPR for framebuffer units). */
export const OFFSET_MAGNITUDE_CSS_PX = 120;
